import { render, staticRenderFns } from "./PageContentPlaceholder.vue?vue&type=template&id=7b3fba91&scoped=true&"
import script from "./PageContentPlaceholder.vue?vue&type=script&lang=js&"
export * from "./PageContentPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./PageContentPlaceholder.vue?vue&type=style&index=0&id=7b3fba91&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b3fba91",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VIcon,VProgressCircular,VRow})
